import type { CommonDict } from '../en/common';

export const common: CommonDict = {
  actions: {
    cancel: 'Avbryt',
    delete: 'Radera',
    create: 'Skapa',
    save: 'Spara',
    edit: 'Redigera',
    close: 'Stäng',
    confirm: 'Bekräfta',
    add: 'Lägg till',
    remove: 'Ta bort',
    search: 'Sök',
    upload: 'Ladda upp',
    download: 'Ladda ner',
    send: 'Skicka',
    retry: 'Försök igen',
    back: 'Tillbaka',
    done: 'Klar',
    copy: 'Kopiera',
    export: 'Exportera',
    view: 'Visa',
    open: 'Öppna',
    rename: 'Byt namn',
    clear: 'Rensa',
    apply: 'Tillämpa',
    select: 'Välj',
    submit: 'Skicka',
    logOut: 'Logga ut',
  },
  states: {
    loading: 'Laddar …',
    saving: 'Sparar …',
    deleting: 'Raderar …',
    creating: 'Skapar …',
    uploading: 'Laddar upp …',
    noResults: 'Inga resultat',
    somethingWentWrong: 'Något gick fel',
  },
  notFound: {
    title: 'Sidan finns inte',
    description: 'Sidan finns inte eller har flyttats.',
    home: 'Till startsidan',
  },
  forms: {
    required: 'Fältet är obligatoriskt',
    invalidEmail: 'Ange en giltig e-postadress',
    invalidValue: 'Ogiltigt värde',
    somethingWentWrong: 'Något gick fel. Försök igen.',
    serverError: 'Något gick fel hos oss. Försök igen senare.',
  },
  switcher: {
    label: 'Språk',
  },
};
